import request from '@/utils/request'
import requestJson from '@/utils/requestJson'

export function getList(data) {
  return request({
    url: '/admin/order_join/getList',
    method: 'get',
    params: data
  })
}
export function up_check_status(data) {
  return request({
    url: '/admin/order_join/up_check_status',
    method: 'post',
    data
  })
}
export function getOne(data) {
  return request({
    url: '/admin//order_join/getOne',
    method: 'get',
    params: data
  })
}

export function upPrice(data) {
  return request({
    url: '/admin/order_join/up_price',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/franchiseInvoice.js